import { Chip, Box, useTheme } from '@mui/material';
import Iconify from 'src/components/iconify';
import { fPercent } from 'src/utils/format-number';

interface CompareChipProps {
  value: number;
  trendColor?: string;
  iconColor?: string;
  backgroundColor?: string;
  invertedColor?: boolean;
}

export default function CompareChip({ value, trendColor, iconColor, backgroundColor, invertedColor = false }: CompareChipProps) {
  const theme = useTheme();
  const isSpecialValue = value === null || isNaN(value) || !isFinite(value);
  
  const trendIcon = isSpecialValue || value === 0 ? '' : (value < 0 ? 'solar:double-alt-arrow-down-bold-duotone' : 'solar:double-alt-arrow-up-bold-duotone');

  const formattedValue = isSpecialValue ? '  +∞  ' : (value === 0 ? fPercent(value) : (value > 0 ? `+${fPercent(value)}` : fPercent(value)));

  const getTrendColor = () => {
    if (value < 0) {
      return invertedColor ? theme.palette.success.main : theme.palette.error.main;
    }
    return invertedColor ? theme.palette.error.main : theme.palette.success.main;
  };

  return (
    <Chip
      icon={
        <Box
          sx={{
            width: 24,
            height: 18,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            position: 'relative',
            left: 0,
          }}
        >
          <Iconify
            icon={trendIcon}
            color={getTrendColor()}
            sx={{
              fontSize: { xs: 6, lg: 8 },
            }}
          />
        </Box>
      }
      label={formattedValue}
      variant="outlined"
      size="small"
      sx={{
        width: 90,
        '& .MuiChip-root': {
          display: 'flex',
          justifyContent: 'flex-start',
        },
        '& .MuiChip-icon': {
          marginLeft: 0,
          marginRight: 0,
        },
        '& .MuiChip-label': {
          pr: 1,
          pl: 0,
          fontSize: isSpecialValue ? { xs: 12, lg: 14 } : { xs: 10, lg: 12 },
          color: theme.palette.mode === 'dark' ? 'white' : theme.palette.text.primary,
          textAlign: 'left',
          flex: 1,
        },
        border: 'none',
        backgroundColor: 'transparent',
      }}
    />
  );
} 